import React,{useState} from "react"
import { Box, Button, Grid, Typography,TableContainer,TableCell,TableRow,Table,TableHead, Paper, TableBody,TablePagination} from '@mui/material'
import { TableouterBoxStyle, paperStyle, headerBoxStyle,internalBoxStyle,typographyStyle,headerCellStyle} from './WORKersDashboardTable_css';
import {mediumGrey,headingBlue, lightGrey, maroon} from "../../../assets/colors"
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import IconButton from '@mui/material/IconButton';
import Pagination from '@mui/material/Pagination';

function TablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <KeyboardArrowLeft style={{color:headingBlue}}/>
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <KeyboardArrowRight style={{color:headingBlue}}/>
      </IconButton>
    </Box>
  );
}

const WORKersDashboardTable = (props) =>{
const data = props.data
const onNameClick = props.onNameClick 

const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(5);

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};


return(
<>
<Box style={TableouterBoxStyle}>

                <Paper style={paperStyle}>
                   <Box style={headerBoxStyle}>
            <Box style={internalBoxStyle}>
              <Typography style={{...typographyStyle, fontSize:"1.3rem"}}> WORKers</Typography>
            </Box>
          </Box>
          <Paper style={{ border: '2px solid #D9D9D9',
    padding: "0.1rem"}}>
          <Box>
             <TableContainer
              style={{ height: "44vh", "&::-webkit-scrollbar":{
                                 display: 'none'
                               },
                               scrollbarWidth: "none"}}>
              <Table stickyHeader >
        <TableHead style={{backgroundColor: "grey"}}>
                  <TableRow style={{backgroundColor: "white", padding: '0rem 0rem 0rem 0rem'}}>
                    <TableCell style={{...headerCellStyle, color:headingBlue,background:lightGrey,padding:"0.6rem"}}>
                     Name
                    </TableCell>
                    <TableCell style={{...headerCellStyle ,background:lightGrey,}}>
                      Gender
                    </TableCell>
                     <TableCell style={{...headerCellStyle ,background:lightGrey,}}>
                      Contact Number
                    </TableCell>
                     <TableCell style={{...headerCellStyle ,background:lightGrey,}}>
                      District / State
                    </TableCell>
                     <TableCell style={{...headerCellStyle ,background:lightGrey,}}>
                      Membership Id
                    </TableCell>
                     <TableCell style={{...headerCellStyle ,background:lightGrey,}}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {data?.length > 0 ? (
        data.map((worker) => (
          <TableRow key={worker.id}>
            <TableCell style={{...headerCellStyle, cursor: "pointer", color: headingBlue}}
             onClick={() => onNameClick(worker)}
            >{worker.name}</TableCell>
            
            <TableCell style={{...headerCellStyle}}>{worker.gender}</TableCell>
            <TableCell style={{...headerCellStyle}}>{worker.contactNumber}</TableCell>
            <TableCell style={{...headerCellStyle}}>{worker.district}<br></br>{worker.chapter}</TableCell>
            <TableCell style={{...headerCellStyle}}>..</TableCell>
            <TableCell style={{...headerCellStyle}}>..</TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={4} align="center">
            No data found
          </TableCell>
        </TableRow>
      )}
                </TableBody>
              </Table>
          </TableContainer>
          </Box>
          </Paper>
          <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
> 

  <Typography variant="body2"
      sx={{
      fontWeight: 400,
      color: maroon,
      fontSize: "0.95rem",
    }}>

    {`${page * rowsPerPage + 1}–${Math.min(
      (page + 1) * rowsPerPage,
      data?.length || 0
    )} of ${data?.length || 0}`}
  </Typography>

 <Pagination
  count={Math.ceil((data?.length || 0) / rowsPerPage)}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  hidePrevButton={false}
  hideNextButton={false}
  siblingCount={0}
  boundaryCount={0}
  showFirstButton={false}
  showLastButton={false}
 sx={{
  fontWeight: 600,
  color: headingBlue,
  "& .Mui-selected": {
    backgroundColor: headingBlue,
    color: "#fff",
  },
}}
/>

   <TablePagination
    component="div"
    count={data?.length || 0}
    page={page}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    rowsPerPageOptions={[5, 10, 25]}
    labelDisplayedRows={() => ""}
    ActionsComponent={() => null}

    sx={{
    color: headingBlue,
    fontWeight: 600}}

  />
</Box>
                </Paper>
              </Box>

</>
)
}

export default WORKersDashboardTable;